<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">

    <div class="contents-wrapper">

      <div class="main-contents">

        <div class="flex-container flex-align-left flex-direction-column">

          <detail-row-component title="말머리" :inner-vertical="true">

            <layout-radio-button v-model="editable.tag"
                                 :name="`tag-selector${rowIndex}`"
                                 :select-list="['공지', '이벤트', 'FAQ']"
                                 :view-list="['공지', '이벤트', 'FAQ']"/>

            <layout-blank :value="12"/>

            <layout-info title="공지 : 고객 전달 내용 (서비스 지역 확대 / 배송 지연 등에 대한 안내)"/>
            <layout-info title="이벤트 : 이벤트"/>
            <layout-info title="FAQ : 자주하는 질문 (사용법 안내, 고객센터 문의, 도움말 등)"/>

          </detail-row-component>

          <detail-row-component title="제목">

            <layout-input v-model="editable.title"
                          placeHolder="제목을 입력해주세요."
                          :regex="regex(1,1000).ko_en_num"/>

          </detail-row-component>

          <detail-row-component title="컨텐츠 URL" :inner-vertical="true">

            <layout-input v-model="editable.contentUrl"
                          placeHolder="ex) https://winepointblog.wordpress.com/1"
                          regex="https://winepointblog.wordpress.com/"/>

            <layout-info title="* 컨텐츠 URL에는 https://winepointblog.wordpress.com/ 가 포함되어야 합니다."/>

          </detail-row-component>

          <detail-row-component title="공개 날짜">

            <layout-date-picker v-model="editable.beginAt"
                                place-holder="공개 날짜를 선택해주세요."/>

          </detail-row-component>

          <detail-row-component title="컨텐츠 요약">

            <layout-input v-model="editable.summary"
                          placeHolder="개요를 입력해주세요."/>

          </detail-row-component>

          <detail-row-component title="발행">

            <layout-switch-button v-model="editable.isPublished"/>

          </detail-row-component>

        </div>

      </div>

    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from '@/utils/utils';

import DetailRowWrapper from '@/spa/components/detail-row/DetailRowWrapper';
import DetailRowComponent from '@/spa/components/detail-row/DetailRowComponent';

import LayoutInput from '@/spa/components/LayoutInput';
import LayoutSwitchButton from '@/spa/components/LayoutSwitchButton';
import LayoutDatePicker from '@/spa/components/LayoutDatePicker';
import LayoutInfo from '@/spa/components/LayoutInfo';
import LayoutRadioButton from '@/spa/components/LayoutRadioButton';
import LayoutBlank from '@/spa/components/LayoutBlank';

export default {
  name: 'NoticeEditor',
  components: {
    LayoutInfo,
    DetailRowWrapper,
    DetailRowComponent,
    LayoutInput,
    LayoutSwitchButton,
    LayoutRadioButton,
    LayoutDatePicker,
    LayoutBlank,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    regex(min = 0, max = 0) {
      return regex(min, max);
    },

    initTag(text) {
      if (text === '공지' || text === '이벤트' || text === 'FAQ') {
        return text;
      }

      return '공지';
    },

    getTagBgColor(text) {
      return text === '공지' ? '#89d25c' : text === '이벤트' ? '#ff5498' : text === 'FAQ' ? '#8147f7' : '#ffffff';
    },

    async submit() {
      this.editable.id = this.rowData.id;
      this.editable.tagBgColor = this.getTagBgColor(this.editable.tag);

      const validateResult = multipleValidate([
        validate({ message: '제목', target: this.editable.title, regex: this.regex(1, 100).ko_en_num }),
        validate({ message: '컨텐츠 URL', target: this.editable.contentUrl, regex: 'https://winepointblog.wordpress.com/' }),
      ]);

      if (this.editable.isPublished && validateResult.flag) {
        this.$toast(validateResult.message);
        return;
      }

      this.editable.contentUrl = this.editable.contentUrl.replace('https://winepointblog.wordpress.com', '');

      const result = await this.$store.dispatch('updateNotice', this.editable);

      if (result.response) {
        this.$table.updateField();
      }

      this.$toast(result.message);
    },

    cancel() {
      this.$table.updateField();
    },
  },
  data() {
    return {
      editable: {
        title: this.rowData.title,
        contentUrl: !this.rowData.content_url ? '' : `https://winepointblog.wordpress.com${this.rowData.content_url}`,
        beginAt: this.rowData.begin_at,
        isPublished: this.rowData.is_published,
        tag: this.initTag(this.rowData.tag),
        tagBgColor: this.rowData.tag_bg_color,
        summary: this.rowData.summary,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: auto;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;
    width: 60%;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/notice/detail-row/NoticeEditor.vue